/// <amd-module name="Build/Designer/Util/File" />
import * as Resources from "Build/Designer/Resources";


/**
 * Gets the file name from the full path file name
 */
export function getFileName(path: string): string {
    if (path) {
        const lastSegment = path.lastIndexOf("/");
        return lastSegment >= 0 ? path.substr(lastSegment + 1) : path;
    }
    return "";
}

/**
 * Gets the parent path from the full path file name
 */
export function getParentPath(path: string): string | undefined {
    let parentPath: string | undefined;
    const trimmedPath = trimTrailingSlashes(trimLeadingSlashes(path));
    if (trimmedPath) {
        parentPath = "/";
        const lastSlash = trimmedPath.lastIndexOf("/");
        if (lastSlash >= 0) {
            parentPath += trimmedPath.substr(0, lastSlash);
        }
    }
    return parentPath;
}

const invalidFileChars = new Set(["\\", ":", "*", "?", '"', "<", ">", "|"]);
const invalidFileEndChars = new Set(["/", "."]);

/**
 * Determines if the given full filename is a legal YAML file name and return undefined if so,
 * otherwise a message that indicates the reason why it is invalid.
 */
export function getInvalidFileNameMessage(path: string): string | undefined {
    path = trimFilePath(path);
    if (path.indexOf("//") > -1) {
        return Resources.FileInvalidDoubleSlash;
    }

    path = trimLeadingSlashes(path);
    if (!path) {
        return Resources.FileInvalidEmpty;
    }
    if (Array.from(path).some(c => invalidFileChars.has(c))) {
        return Resources.FileInvalidCharacters;
    }
    if (path.split("/").some(part => { return !part || invalidFileEndChars.has(part.substr(part.length - 1)) })) {
        return Resources.FileInvalidEndCharacters;
    }
    return undefined;
}

/**
 * Trims spaces from the file and folder names in the full file path
 */
export function trimFilePath(path: string) {
    return (path || "").split("/").map(part => (part || "").trim()).join("/");
}

/**
 * Trims all "/" from the start of a file path
 */
export function trimLeadingSlashes(path: string): string {
    while (path && path[0] === "/") {
        path = path.substr(1);
    }
    return path;
}

/**
 * Trims all "/" from the end of a file path
 */
export function trimTrailingSlashes(path: string): string {
    while (path && path[path.length - 1] === "/") {
        path = path.substr(0, path.length - 1);
    }
    return path;
}

/**
 * Returns a filename with a yml extension if it doesn't already have one.
 */
export function ensureYamlExtension(name: string): string {
    const lower = name.toLocaleLowerCase();
    if (!(lower.endsWith(".yml") || lower.endsWith(".yaml"))) {
        name = name + ".yml";
    }
    return name;
}
